import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { InputFieldComponent } from '@components/dynamic-form/input-field.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { DateControl } from '@components/dynamic-form/date-control';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY hh:mm',
  },
  display: {
    dateInput: 'DD/MM/YYYY hh:mm',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-date-time-input',
  templateUrl: './date-time-input.component.html',
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class DateTimeInputComponent extends InputFieldComponent implements OnInit {
  @Input() meta!: DateControl;
  @Input() form!: FormGroup;
  @Input() max: any;
  @Input() indexRow: number = null;
  @Input() keyformArrayName: any;
  today: Date = new Date();
  protected control: AbstractControl<any>;

  constructor(private dateAdapter: DateAdapter<Date>) {
    super();

    this.today.setDate(this.today.getDate());
    this.dateAdapter.setLocale('it');
  }

  get controlArray() {
    return this.form.controls[this.keyformArrayName] as FormArray;
  }

  ngOnInit(): void {
    this.setControl();
  }
}
